

<template>

  <div class="outer-wrap">

    <component :is=" properDashboard "></component>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import AdminDashboard from './dashboards/Admin';
  import UserDashboard from './dashboards/User';
  import MerchantDashboard from './dashboards/Merchant';
  import LoadingScreen from './misc/LoadingScreen';

  export default {

    name: 'home',
    computed: {

      ...mapGetters({

        isAuth      : 'auth/isAuth',
        activeRole  : 'auth/activeRole',
        profileInfo : 'auth/profileInfo'
      }),
      properDashboard() {

        switch( this.activeRole ){

          // took this crouting out for now, will always show the user dashboard now until the need for other dashboards arises
          // case "admin":

          //   return 'admin-dashboard';
          // case "merchant":

          //   return 'merchant-dashboard';
          // case "user":

          //   return 'user-dashboard';
          default:

            // return 'loading-screen';
            return 'user-dashboard';
        }
      }
    },
    created(){

      if( this.isAuth && this.profileInfo.userId == null ){
        // this condition will exist when the user has a JWT but has not yet initialized the app..
        // this occurs when the user is just entering via text-auth, or by the standard login process

        this.$store.dispatch( 'auth/initApp' );
      }
    },
    components: {

      AdminDashboard,
      UserDashboard,
      MerchantDashboard,
      LoadingScreen
    }
  }
</script>

<style scoped>

  .outer-wrap{

    margin: 0px auto;
    width: 100%;
    max-width: 500px;
  }

  @media screen and ( min-width: 420px ){


  }

  @media screen and ( min-width: 768px ){

    .outer-wrap{


    }
  }

  @media screen and ( min-width: 1335px ){

    .outer-wrap{

    }
  }

</style>
